<script setup lang="ts">
interface DropdownItemProps {
  label?: string;
  iconLeft?: string;
  iconRight?: string;
}

const { label = null, iconLeft = null, iconRight = null } = defineProps<DropdownItemProps>();
</script>

<template>
  <button class="dropdown-item" data-is-final="true">
    <span v-if="iconLeft !== null" :class="iconLeft" class="icon left"></span>
    <span v-if="label" class="label">{{ label }}</span>
    <span v-if="iconRight" :class="iconRight" class="icon right"></span>
  </button>
</template>

<style scoped>
.dropdown-item {
  --height: var(--numbers-40);

  display: inline-flex;
  min-width: 100%;
  height: var(--height);
  align-items: center;
  padding: var(--numbers-16);
  border: 0;
  background-color: transparent;
  color: var(--content-secondary);
  cursor: pointer;
  letter-spacing: -0.015em;
  text-align: left;
  transition: background-color var(--animation-duration) var(--animation-easing);
  white-space: nowrap;

  &:hover {
    background-color: var(--background-secondary);
  }

  .icon.left:has(+ .label) {
    padding-right: var(--numbers-8);
  }

  .label + .icon.right {
    padding-left: var(--numbers-8);
  }
}
</style>
